export default __webpack_public_path__ + "static/media/1_Thunderstorm Soundscape - 30s sample.205ff21a.mp3";